// extracted by mini-css-extract-plugin
export default {"summary":"Q8_miP","container":"FrlNr4","info":"zxKSdr","title":"hEnmg3"};